'use strict';

(function(ifsConfigUrl, ifsOptions){
  // Define Defaults for TYPO3-Searchbar
  var ifsOptions = {},
      defaultOptions = {
      configurl: ifsConfigUrl || null,
      cors: true,
      withCredentials: true,
      sbTarget: '#ifs-searchbar',
      rlTarget: '#ifs-resultlist',
      customConfig: {
        "debug": false
      },
      callbacks: {
        onLoad: () => {
          var searchState = window.location.search.toString();
          if (!searchState)
          {
            searchState = 'ifs_app_states_0=id:0;sSearchTerm:*';
          }

          IFS.setExternalTabsStateFromUrl(searchState);
        },
        onStateChange: () => {}
      }
    };

  /**
   * @usage to apply custom overrides on per-site basis:
   *   <script id="ifs-searchbar-config" type="application/json">
   *   {
   *     "configurl": "https://{{ifinder-config-uri}}/iFinder/config.json",
   *     "sbTarget": "#ifs-searchbar",
   *     "rlTarget": "#ifs-resultlist"
   *   }
   *   </script>
   * @returns {any|null}
   */
  IFS.getWebConfiguration = function() {
    if (!this.webConfiguration)
    {
      var n = document.getElementById('ifs-searchbar-config');
      if (!n || !n instanceof Object || !n.text) return {};

      try
      {
        this.webConfiguration = Object.fromEntries(
          Object.entries(JSON.parse(n.text) || {})
            .filter(([_, v]) => v != null)
        );
      }
      catch (e)
      {
        console.error(e, 'Payload from #\'ifs-searchbar-config\' (application/json)', n.text);
      }
    }

    return this.webConfiguration || {};
  };

  // merge configurations
  ifsOptions = Object.assign(
    {}, defaultOptions,
    ifsOptions || {},
    IFS.getWebConfiguration()
  );

  IFS.eventbus.addEventListener('search_triggered', function(e, data) {
    if (data.query === '*') {
      document.getElementById('ifs-sb-search_input').value = '';
      IFS.eventbus.removeEventListener('search_triggered', this);
    }
  });

  IFS.initClient(ifsOptions);
})();
